import { Component, OnInit, ElementRef, ChangeDetectionStrategy, EventEmitter, Output, Input } from '@angular/core';
import { FormBuilder, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateHelper } from '@asamco/application-link/shared';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { FormHelpers } from '@asamco/utils';
import { DxTextBoxModule, DxLookupModule, DxDateBoxModule } from 'devextreme-angular';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { AsValidatorDirective } from '@asamco/base';
import { LinkTemplate } from '../interfaces/link-template.interface';
import { MockDataUploadRequestModel } from '../interfaces/mock-data-upload-request-model.interface';

declare var window: any;
@Component({
    templateUrl: './mock-data-create-modal.component.html',
    selector: 'mock-data-create-modal',
    styleUrls: ['mock-data-create-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        DxTextBoxModule,
        AsValidatorDirective,
        DxLookupModule,
        DxDateBoxModule,
        NgFor,
        AsyncPipe,
    ],
})
export class MockDataCreateModalComponent implements OnInit {
	@Output()
	showToast = new EventEmitter<string>();

	linkTemplates: LinkTemplate[];

	visible$ = new BehaviorSubject<boolean>(false);

	form;

	private subject: Subject<MockDataUploadRequestModel>;

	constructor(public el: ElementRef, public fb: FormBuilder) {
	}

	ngOnInit() {
		this.initForm();
	}

	hide() {
		this.visible$.next(false);
	}

	show() {
		this.visible$.next(true);
		this.subject = new Subject<MockDataUploadRequestModel>();
		return this.subject;
	}

	ok() {
		if (FormHelpers.validateForm(this.form)) {
			this.subject.next(this.form.value);
			this.visible$.next(false);
		}
	}

	cancel() {
		this.hide();
		this.subject.complete();
	}

	private initForm() {
		const startDate = DateHelper.firstDayOfMonth(new Date());
		const endDate = new Date(startDate);
		endDate.setMonth(endDate.getMonth() + 1);

		this.form = this.fb.group({
			name: new FormControl('New Mock Data', Validators.required),
			linkTemplateId: new FormControl(null, Validators.required),
			startDate: new FormControl(startDate, Validators.required),
			endDate: new FormControl(endDate, Validators.required),
			isTransient: new FormControl(true, Validators.required)
		});
	}
}
